import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/app/app-state';
import pagesRoutes from './pages/pages-routes';
import translatedRoutes from './pages/translated-pages-routes';

Vue.use(VueRouter);

const appRoutes = [
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ './404.vue'),
  },
];

const routes = [...pagesRoutes, ...appRoutes, ...translatedRoutes];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.name === from.name) {
      return null;
    }
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      };
    }
    if (
      to.path === from.path &&
      (to.query?.modal === 'registration' || from.query?.modal === 'registration')
    ) {
      return null;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (from?.matched.length) {
    store.commit('setLastInternalRoute', from.fullPath);
  }
  next();
});

export default router;
